import React, { useLayoutEffect, useEffect, useState, useRef } from 'react';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/

var classnames = createCommonjsModule(function (module) {
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement && window.navigator && window.navigator.userAgent);
var useIsomorphicLayoutEffect = canUseDOM ? useLayoutEffect : useEffect;

var regexISO = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*))(?:Z|(\+|-)([\d|:]*))?$/;

var JSONDateParser = function JSONDateParser(key, value) {
  try {
    if (typeof value === 'string') {
      var match = regexISO.exec(value);

      if (match) {
        return new Date(value);
      }
    }
  } catch (ex) {
    console.error("Failed to parse JSON date to string.\n".concat(key, ": ").concat(value, "\n"), ex);
    return undefined;
  }

  return value;
};

var jsonParseBodyWithDate = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(body) {
    var text, parsed;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return body.text();

          case 2:
            text = _context.sent;
            parsed = JSON.parse(text, JSONDateParser);
            return _context.abrupt("return", parsed);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function jsonParseBodyWithDate(_x) {
    return _ref.apply(this, arguments);
  };
}();

var Overview = function Overview(_ref) {
  var header = _ref.header,
      itemsProps = _ref.items,
      url = _ref.url,
      pageProp = _ref.page,
      _ref$paging = _ref.paging,
      paging = _ref$paging === void 0 ? 'infinite' : _ref$paging,
      pageSizeProp = _ref.pageSize,
      hasMoreItemsProp = _ref.hasMoreItems,
      loadMoreItemsError = _ref.loadMoreItemsError,
      loadMoreItemsBtn = _ref.loadMoreItemsBtn,
      noItemsText = _ref.noItemsText,
      renderItem = _ref.renderItem;

  var _useState = useState(pageSizeProp),
      _useState2 = _slicedToArray(_useState, 2),
      pageSize = _useState2[0],
      setPageSize = _useState2[1];

  var _useState3 = useState(pageSize ? itemsProps.slice(0, pageSize) : itemsProps),
      _useState4 = _slicedToArray(_useState3, 2),
      items = _useState4[0],
      setItems = _useState4[1];

  var _useState5 = useState(pageProp || 1),
      _useState6 = _slicedToArray(_useState5, 2),
      page = _useState6[0],
      setPage = _useState6[1];

  var _useState7 = useState(hasMoreItemsProp || false),
      _useState8 = _slicedToArray(_useState7, 2),
      hasMoreItems = _useState8[0],
      setHasMoreItems = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      loading = _useState10[0],
      setLoading = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      hasError = _useState12[0],
      setHasError = _useState12[1];

  useEffect(function () {
    setItems(pageSize ? itemsProps.slice(0, pageSize) : itemsProps);
  }, [itemsProps, pageSize]);

  var loadNextPage = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var pageUrl, request, response;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);
              setHasError(false);
              _context.prev = 2;
              pageUrl = [url, "page=".concat(page + 1)].join((url || '').indexOf('?') === -1 ? '?' : '&');
              _context.next = 6;
              return fetch(pageUrl);

            case 6:
              request = _context.sent;

              if (request.ok) {
                _context.next = 9;
                break;
              }

              throw new Error("Status not ok for request: ".concat(JSON.stringify(request)));

            case 9:
              _context.next = 11;
              return jsonParseBodyWithDate(request);

            case 11:
              response = _context.sent;
              setItems([].concat(_toConsumableArray(items), _toConsumableArray(response.items)));
              setPage(response.page || page);
              setHasMoreItems(response.hasMoreItems || false);
              _context.next = 21;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](2);
              console.error(_context.t0);
              setHasError(true);

            case 21:
              _context.prev = 21;
              setLoading(false);
              return _context.finish(21);

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 17, 21, 24]]);
    }));

    return function loadNextPage() {
      return _ref2.apply(this, arguments);
    };
  }();

  var toggle = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setItems(itemsProps);
              setPageSize(itemsProps.length);

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function toggle() {
      return _ref3.apply(this, arguments);
    };
  }();

  var loadMoreBtnRef = useRef(null);
  useIsomorphicLayoutEffect(function () {
    if (paging !== 'infinite' || !loadMoreBtnRef.current || hasError) return;
    var observer = new IntersectionObserver(function (entries) {
      return entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        if (!loading) loadNextPage();
      });
    }, {
      threshold: 1,
      rootMargin: '400px'
    });
    observer.observe(loadMoreBtnRef.current);
    return function () {
      observer.disconnect();
    };
  });
  return React.createElement("div", {
    className: "overview"
  }, React.createElement("div", {
    className: "overview__wrapper"
  }, header && React.createElement("div", {
    className: "overview__header"
  }, header.icon && React.createElement("div", {
    className: "overview__header-icon-wrapper"
  }, React.createElement("img", {
    src: header.icon,
    alt: "",
    className: "overview__header-icon"
  })), React.createElement("div", {
    className: "overview__header-title"
  }, header.title)), items.length > 0 ? React.createElement("ul", {
    className: "overview__list"
  }, items.map(function (props, i) {
    return React.createElement("li", {
      key: JSON.stringify(_objectSpread2({
        i: i
      }, props)),
      className: classnames('overview__list-item', {
        'overview__list-item--has-link': props.url
      })
    }, renderItem(props));
  })) : React.createElement("div", {
    className: "overview__no-items-text"
  }, noItemsText), loading ? React.createElement("div", {
    className: "overview__loading"
  }) : React.createElement(React.Fragment, null, hasMoreItems && url && React.createElement("button", {
    className: "overview__load-more-btn",
    ref: loadMoreBtnRef,
    onClick: function onClick() {
      return loadNextPage();
    }
  }, loadMoreItemsBtn), paging === 'toggle' && pageSize && itemsProps.length > pageSize && React.createElement("button", {
    className: "overview__load-more-btn",
    onClick: function onClick() {
      return toggle();
    }
  }, loadMoreItemsBtn), hasError && React.createElement("div", {
    className: "overview__error"
  }, loadMoreItemsError))));
};

export default Overview;
//# sourceMappingURL=react-overview.es.js.map
